module.exports = __webpack_public_path__ + "static/img/装饰14.e34bf74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰14.svg
// module id = uoxA
// module chunks = 2